<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon"><i class="pi pi-pencil"></i></div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">تعديل طريقة الدفع</h1>
        <p class="form-page-header__subtitle" v-if="method">{{ method.name }}</p>
      </div>
    </div>

    <Loading v-if="loading" />
    <div v-else-if="!method" class="ds-container">
      <div class="empty-state empty-state--card">
        <div class="empty-state__icon"><i class="pi pi-exclamation-triangle"></i></div>
        <h3 class="empty-state__title">لم يتم العثور على طريقة الدفع</h3>
        <p class="empty-state__desc">ربما تم حذفها مسبقاً.</p>
        <router-link to="/payment-methods" class="ds-btn ds-btn--primary empty-state__action">رجوع لطرق الدفع</router-link>
      </div>
    </div>
    <PaymentMethodForm v-else :method="method" />
  </div>
</template>

<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import Loading from '@/components/global/loading.vue';
import PaymentMethodForm from './PaymentMethodForm.vue';
import { usePaymentMethodStore } from '@/stores/usePaymentMethodStore.js';

export default {
  name: 'PaymentMethodEdit',
  components: { Breadcrumb, Loading, PaymentMethodForm },
  data() {
    return {
      loading: true,
      method: null,
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'طرق الدفع', path: '/payment-methods' },
        { name: 'تعديل', path: '#' },
      ],
    };
  },
  async mounted() {
    try {
      this.method = await usePaymentMethodStore().fetchMethod(this.$route.params.id);
    } catch { this.method = null; } finally {
      this.loading = false;
    }
  },
};
</script>
